import { useI18n } from "../i18n";
import { getContentByLocale } from "../content";
import { PageSeo } from "../components/seo/PageSeo";

export default function PrivacyPage() {
  const { locale } = useI18n();
  const content = getContentByLocale(locale);

  return (
    <div className="section">
      <PageSeo title={content.privacy.title} description={content.privacy.description} />
      
      <div className="info-panel">
        <h1>{content.privacy.title}</h1>
        <p style={{ color: "var(--color-accent)", fontSize: "0.8rem", marginTop: "8px" }}>
          {locale === "pt" ? "Versão" : "Version"}: {content.privacy.version}
        </p>
        
        <div className="privacy-body">
          {content.privacy.sections.map((section, idx) => (
            <section key={idx} className="privacy-section">
              <h2>{section.title}</h2>
              <p>{section.content}</p>
            </section>
          ))}
        </div>
      </div>
    </div>
  );
}
